import { InputLabels, SelectField } from '../../../generic/InputField';
import React, { useMemo, useState } from 'react';
import { mergeClassNames } from '../../../../utils';

import { IconTypes } from '../../../generic/Icon';
import Image from '../../../generic/Image';
import { Link } from 'gatsby';
import { PrimaryButton } from '../../../generic/Button';
import RichText from '../../../generic/RichText';
import TransitionOpacityReveal from '../../../generic/TransitionOpacityReveal';
import styles from './index.module.scss';

export default function MainProduct({ product, children, addToQuote, mounts }) {
  mounts = mounts?.map(({ price, mount, id }) => ({ ...mount, price, id })) || product.mounts;
  const link = ['/devices', product.devicePage?.slug].join('/');

  const selectableItems = useMemo(() => (mounts ? mounts : [product]), [mounts, product]);
  const [selectedMountOrProductId, setSelectedMountId] = useState(selectableItems[0]?.id);

  const selectedMountOrProduct = useMemo(() => mounts?.find(({ id }) => id === selectedMountOrProductId), [
    mounts,
    selectedMountOrProductId,
  ]);

  function getImage(mount, product) {
    return mount.image || product.images[0].image;
  }

  const mountingOptions = useMemo(
    () =>
      mounts
        ? [
            ...mounts?.map(mount => ({
              value: mount.id,
              displayValue: mount.heading,
            })),
          ]
        : [],
    [mounts]
  );

  const onSelectedMount = mountId => {
    setSelectedMountId(mountId);
    return mountId;
  };

  return (
    <div className={styles.mainProduct}>
      <div className={mergeClassNames([styles.padding, styles.details])}>
        <h3 className={styles.mainTitle}>{product.heading}</h3>
        <RichText className={styles.description}>{product.description?.description}</RichText>
        {Boolean(link) && (
          <span className={styles.description}>
            <Link to={link}>Learn more</Link>
          </span>
        )}

        {mountingOptions.length > 0 && (
          <form name="main-product-mount-selector" className={styles.form}>
            <InputLabels htmlFor="mount" id="mount">
              <SelectField
                className={styles.selectfieldPriority}
                handleSelectChangeCallback={onSelectedMount}
                options={mountingOptions}
                id="mount"
                name="mount"
                defaultValue={''}
              />
            </InputLabels>
          </form>
        )}
      </div>

      <div className={mergeClassNames(styles.productImage, styles.padding)}>
        <div className={styles.productImageInner}>
          {selectableItems.map((prodMount, index) => {
            let isVisible = selectedMountOrProduct === prodMount || !selectedMountOrProduct;
            return (
              <TransitionOpacityReveal key={index} isVisible={isVisible} className={styles.imageContainer} slow>
                {Boolean(getImage(prodMount, product)?.fluid) && (
                  <Image
                    fluid={getImage(prodMount, product)?.fluid}
                    style={{ objectFit: 'contain', maxHeight: '300px' }}
                    alt={getImage(prodMount, product).description}
                  />
                )}
              </TransitionOpacityReveal>
            );
          })}
        </div>
      </div>

      <div className={styles.padding}>
        <div className={styles.clearLeft}>{children && children.props?.products?.length ? children : null}</div>
        <PrimaryButton
          iconType={IconTypes.quote}
          clickHandler={() => addToQuote(selectedMountOrProductId)}
          className={styles.addToQuoteButton}
        >
          Add to quote
        </PrimaryButton>
      </div>
    </div>
  );
}
